<template>
    <div>
        <form @submit.prevent="submitForm">
        <DynamicForm
            :schema="schema"
            v-model="form"
            @status="saveStatus"
            ref="dynamicForm"
        />
        </form>
        <vs-button
            :active="true"
            @click="searchForUser(form.email)"
            >{{ $t("common.next") }} <i class="material-icons">navigate_next</i>
        </vs-button>
        <!-- <login-form v-if="this.emailOk && this.$store.state.askForPass"></login-form> -->
        <vs-dialog blur v-model="askForPassNewUser" v-on:close="askForPassNewUser=false">
            <!-- prevent-close not-close -->
            <template #header>
                <div class="modal-dialog modal-sm">
                <form>
                    <div class="modal">
                        <div class="modal-header"><i class="material-icons" style="font-size: 44px;">vpn_key</i></div>
                        <h4 class="not-margin center">{{$t("access.msg-pass")}}</h4>
                        <vs-input hidden
                            ref="username"
                            autocomplete="username">
                        </vs-input>
                        <div class="con-form">
                            <vs-input
                            id="loginpass"
                            name="password"
                            type="password"
                            autocomplete="current-password"
                            v-model="pass"
                            :placeholder="$t('access.password')"
                            :visiblePassword="hasVisiblePassword"
                            >
                            <!--
                            v-on:keyup.enter="access()" -->
                            <template #icon>
                                <i class="material-icons">lock</i>
                            </template>
                            </vs-input>
                            <vs-tooltip right>
                            <span
                                style="position: relative; display: inline; top: -32px; left: 140px"
                                @click="hasVisiblePassword = !hasVisiblePassword"
                            >
                                <i v-if="!hasVisiblePassword" class="material-icons">visibility_on</i>
                                <i v-else class="material-icons">visibility_off</i>
                            </span>
                            <template #tooltip > {{$t('access.show-hide-password')}} </template>
                            </vs-tooltip>

                        </div>
                        <div> 
                            <!-- v-if="passOk" -->
                            <vs-button
                                id="btn-next"
                                disabled
                                success
                                size="mini"
                                flat
                                :active="passOk"
                                @click="savePass()"
                                animation-type="scale"
                                ><i class="material-icons">done</i>{{ $t("common.next") }}
                            </vs-button>
                            <!-- <vs-button
                                danger
                                size="mini"
                                flat
                                :active="true"
                                @click="askForPassNewUser=false"
                                animation-type="scale"
                                ><i class="material-icons">cancel</i>
                            </vs-button> -->
                        </div>
                    </div>
                </form>
                </div>
            </template>

            <template #footer>
                <div class="footer-dialog"></div>
            </template>
    </vs-dialog>
    </div>
</template>
<script>

import store from '@/store.js'
// import router from '@/routes.js'
import schema from '@/data/schemaEmail.json'
import DynamicForm from '@/components/DynamicForm'
// import LoginForm from '@/components/LoginForm'

export default {
    name: 'StepMail',
    components: { DynamicForm }, //, LoginForm },
    props: {
        clickedNext: Boolean,
        currentStep: {},
    },
    data () {
        return {
            askForPassNewUser: false,
            pass: '',
            store,
            schema,
            form: {
                email: this.$store.state.usr.email
            },
            status: null,
            miV: {},
            hasVisiblePassword: false
        }
    },
    mounted() {
        this.miV=this.$refs.dynamicForm.$v
    },
    watch: {
        miV: {
            handler: function (val) {
                if(!val.$invalid) {
                    //Aquí tiene que mandar cada campo del form para que se agregue al objeto form del parent
                    // this.$emit('can-continue', {value: true})
                    var extendedForm = []
                    for(const [key, value] of Object.entries(this.schema)){
                        var extendedField = {}
                        Object.defineProperty(extendedField, 'fid', {
                            enumerable: true,
                            configurable: true,
                            writable: true,
                            value: value.idField
                        })
                        Object.defineProperty(extendedField, 'fname', {
                            enumerable: true,
                            configurable: true,
                            writable: true,
                            value: key
                        })
                        Object.defineProperty(extendedField, 'fvalue', {
                            enumerable: true,
                            configurable: true,
                            writable: true,
                            value: this.form[key]
                        })
                        extendedForm.push(extendedField)
                    }
                    store.commit('appendToRegForm', extendedForm)

                    //Verifica si el email ya existe como usuario Globiz (lo comento para obligar a que haga esto cuando el usuario pulse el botón)
                    //this.searchForUser(this.form.email)
                    // alert('manda el dispatch')
                    // store.dispatch('searhForUser', this.form.email)
                } else {
                    this.$emit('can-continue', {value: false})
                }
            },
            deep: true
            },
    },
    computed: {
        emailOk() {
            if (this.form.email && this.form.email !== '' && !this.miV.$invalid) {
                return true
            } else {
                return false
            }
        },
        passOk() {
            let button = document.querySelector("#btn-next")
            if (this.pass.length > 3) {
                if (button) {
                    button.disabled = false
                }
                return true
            } else {
                if (button) {
                    button.disabled = true
                }
                return false
            }
        }
    },
    methods: {
        searchForUser (email) {
            // console.log("searchForUser en StepMail")
            if (this.emailOk) {
                var that = this
                const axios = require("axios") // eslint-disable-line
                var url = this.$websiteGlobiz + "/api/json-reg-existe-cuenta.php"
                axios
                .post(url, {
                    dev: !(process.env.NODE_ENV === "production"), // eslint-disable-line
                    appid: 1,
                    ide: store.state.evento.ide,
                    email: email
                })
                .then(function (response) {
                    if (!response.data.id == 0) {
                        if (response.data.idInsc == 0){
                            //Si es usuario preexistente
                            store.commit('updateUsrData', response.data)
                            //Según la configuración del evento, solicita la clave o no
                            if (parseInt(store.state.evento.RequiereLogin)==1) {
                                store.commit('askForPass', true)
                            } else {
                                //ver para definir el próximo paso
                                store.commit('nextStep', 0)
                            }
                        } else {
                            store.commit('askForPass', false)
                            if (parseInt(store.state.evento.AdmiteReinsc)==1) {
                                // Aunque el usuario ya está registrado en el evento, 
                                // el mismo está configurado para admitir un nuevo registro con el mismo email
                                store.commit('updateUsrData', response.data)
                                store.commit('nextStep', 0)
                            } else {
                                //El usuario ya esta inscripto a este evento
                                that.$vs.notification({
                                icon: "<i class='bx bx-error' ></i>",
                                color: "warn",
                                position: "top-center",
                                progress: "auto",
                                duration: 3000,
                                border: "warn",
                                title: "Error !",
                                text: that.$t('error.cuenta_ya_inscripta')
                                })
                            }
                        }
                    } else {
                        //Si es nuevo usuario, sigue con los pasos pidiendo todos los datos
                        store.commit('askForPass', false)
                        //Busca si en localstorage hay algo guardado, si el email es el mismo, no hace clear
                        if (!that.store.state.usr.email == email){
                            store.commit('clearUsrData', email )
                        }
                        //Si corresponde, pide clave que va a usar el usuario a crear
                        if (parseInt(store.state.evento.RequiereLogin)==1) {
                            that.askForPassNewUser = true
                        } else {
                            store.commit('nextStep', 0)
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
            }
            store.commit('clearUsrData', email )
        },
        saveStatus (status) {
            this.status = status
        },
        savePass () {
            // console.log('Aqui pide clave')
            // let pass = prompt("Por favor, ingrese clave que utilizará:");
            this.askForPassNewUser = false
            if (this.passOk) {
                var extendedForm = []
                var extendedField = {}
                Object.defineProperty(extendedField, 'fid', {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: 9
                })
                Object.defineProperty(extendedField, 'fname', {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: 'pass'
                })
                Object.defineProperty(extendedField, 'fvalue', {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: this.pass
                })
                extendedForm.push(extendedField)
                store.commit('appendToRegForm', extendedForm)
                store.commit('nextStep', 0)
            }
        }
    },
}
</script>